// LoginPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import {
  TextField,
  Button,
  Container,
  Typography,
  Snackbar,
  Alert,
  Box
} from '@mui/material';
import ContextHelpButton from '../components/ContextHelpButton';

export default function LoginPage() {
  const { loginUser } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);

    try {
      console.log('Attempting login with:', form.username);

      await loginUser(form.username, form.password, (role) => {
        console.log('Role detected:', role);

        if (role === 'artist') window.location.href = '/dashboard/artist';
        else if (role === 'host') window.location.href = '/dashboard/host';
        else if (role === 'buyer') navigate('/dashboard/buyer');
        else if (role === 'admin') navigate('/admin');
        else navigate('/');
      });

      setOpen(true);
    } catch (err) {
      console.error('Login failed:', err.response?.data || err.message);
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Login</Typography>
        <ContextHelpButton section="getting-started" title="Help for signing in" />
      </Box>

      {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Username"
          name="username"
          onChange={handleChange}
          margin="normal"
        />

        <TextField
          fullWidth
          type="password"
          label="Password"
          name="password"
          onChange={handleChange}
          margin="normal"
        />

        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
          Login
        </Button>
      </form>

      {/* 🔗 ADDITIONAL LINKS BELOW FORM */}
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Typography variant="body2">
          <Link to="/reset-password" style={{ color: '#2563eb', textDecoration: 'none' }}>
            Forgot your password?
          </Link>
        </Typography>

        <Typography variant="body2" sx={{ mt: 1 }}>
          Don’t have an account?&nbsp;
          <Link to="/register" style={{ color: '#2563eb', textDecoration: 'none' }}>
            Create one
          </Link>
        </Typography>
      </Box>

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpen(false)} severity="success" sx={{ width: '100%' }}>
          Login successful!
        </Alert>
      </Snackbar>
    </Container>
  );
}
